export type AppLanguage = 'en' | 'es';

export const SUPPORTED_LANGUAGES: readonly AppLanguage[] = ['en', 'es'] as const;
export const DEFAULT_LANGUAGE: AppLanguage = 'en';
export const LANGUAGE_STORAGE_KEY = 'cooltech.lang';
